import React from 'react';
import InfoPayment from './InfoPayment';
import InfoBonifici from './InfoBonifici';
import useWindowSize from 'utils/useWindowSize';
import clx from 'classnames';
import styles from './PageInfo.module.scss';

const PageInfo = ({ bonifici, activeSalon, balanceRows, balance }) => {
  const { isMobile } = useWindowSize();

  return (
    <div
      className={clx(styles.page_info, {
        [styles.page_info_mobile]: isMobile,
      })}
    >
      <InfoPayment balance={balance} isMobile={isMobile} />
      <InfoBonifici
        rows={bonifici}
        activeSalon={activeSalon}
        balanceRows={balanceRows}
        balance={balance}
        isMobile={isMobile}
      />
    </div>
  );
};

export default PageInfo;
